import React from "react";
import ModalBasic from "../../component/ModalBasic";

import ButtonLoader from "../../../components/common/buttonLoader/ButtonLoader";
import CKClassicEditor from "../../../components/ckEditor/CKClassicEditor";

const UpdateLOA = (props) => {
    return (
        <ModalBasic
            id="send-payment-link-modal"
            modalOpen={props.LOAModel}
            setModalOpen={props.setOpenModal}
            title="Save LOA Notes"
        >
            <div className="pb-6 px-7 mt-2">
                <div>
                    <CKClassicEditor
                        key={"sendRejectionReason"}
                        onChange={(e) => props.onTinyEceEditorChange(e, "sendRejectionReason")}
                        data={props.loa}                    
                    />
                   
                </div>
                <div className="text-center">
                    {
                        props && props.isLoadingLOA === true ?
                            <ButtonLoader className="btn btn-blue mt-8" />
                            :
                            <button
                                className={`btn ${props.btn_color ? props.btn_color : 'btn-blue'} text-base text-[#fff] font-bold mt-8`}
                                onClick={() => props.updateCONQUAsLOADetails()}
                            >
                                OK
                            </button>
                    }
                </div>
            </div >
        </ModalBasic>
    );
}
export default UpdateLOA;